import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Ebene 1",
  viewBox: "0 0 44.1 33.8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2c2d33",
      d: "M6.3 33.8h31.5c4.2 0 6.3-2.1 6.3-6.2V6.2C44.1 2.1 42 0 37.8 0H6.3C2.1 0 0 2.1 0 6.2v21.4c0 4.1 2.1 6.2 6.3 6.2M3.2 6.4c0-2.1 1.1-3.2 3.1-3.2h31.4c2 0 3.1 1.1 3.1 3.2v1.7H3.2zm3.2 24.2c-2 0-3.1-1.1-3.1-3.2V12.7h37.6v14.7c0 2.1-1.1 3.2-3.1 3.2zm2.3-6h4.9c1.2 0 2-.8 2-1.9V19c0-1.1-.8-1.9-2-1.9H8.7c-1.2 0-2 .8-2 1.9v3.7c0 1.1.8 1.9 2 1.9"
    }, null, -1)
  ])))
}
export default { render: render }